import axios, { AxiosResponse } from 'axios';
import { reportErrorSentry } from 'src/bff';
import { DomainAttributesValues, InstallationResponse } from 'src/types';
import { getMolecularCdnUrl } from '../get-molecular-cdn-url';

export const getInstallations = async (token: string): Promise<{ attributes: DomainAttributesValues[] }[]> => {
  try {
    const molecularCdnUrl = getMolecularCdnUrl();

    if (!molecularCdnUrl) {
      console.error('Error during fetch.');
      return null;
    }

    const installations: AxiosResponse<InstallationResponse> = await axios.get(
      `${molecularCdnUrl}/request-dps-domain.php?token=${token}&domain=Installation`
    );

    return installations.data.content;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
